import React from "react";

/**
 * AccessGate — IP restrictions & gateway completely removed / bypassed.
 * Renders application children directly.
 */
export default function AccessGate({ children }) {
  return <>{children}</>;
}
